<div class="bordered" *ngIf="list.itemCount">
  <div class="table">
    <div class="head-group sticky">
      <div class="row">
        <!-- cislo spisu -->
        <span class="cell" *ngIf="!hideColumn('folderNumber')">
          <sort-by
            [selected]="'folder.folderNumber' === list.filter.sortOrder.sortBy"
            (sort)="onSort('folder.folderNumber', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Číslo spisu EPD</sort-by>
        </span>

        <!-- cislo gp -->
        <span class="cell" *ngIf="!hideColumn('name')">
          <sort-by
            [selected]="'name' === list.filter.sortOrder.sortBy"
            (sort)="onSort('name', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Číslo GP</sort-by>
        </span>

        <!-- k.u. -->
        <span class="cell" *ngIf="!hideColumn('area')">
          <sort-by
            [selected]="isArray(list.filter.sortOrder) && list.filter.sortOrder[1]?.sortBy === 'minAreaName'"
            (sort)="onSort(['areaCount', 'minAreaName'], $event)"
            [sortDir]="list.filter.sortOrder[0]?.direction"
          >Katastrální území</sort-by>
        </span>

        <span class="cell" *ngIf="!hideColumn('lv')">
          <sort-by
            [selected]="isArray(list.filter.sortOrder) && list.filter.sortOrder[1].sortBy === 'minTitle'"
            (sort)="onSort(['titleCount', 'minTitle'], $event)"
            [sortDir]="list.filter.sortOrder[0]?.direction"
          >LV</sort-by>
        </span>

        <!-- zhotovitel -->
        <span class="cell" *ngIf="!hideColumn('supplier')">
          <sort-by
            [selected]="'supplier.companyName' === list.filter.sortOrder.sortBy"
            (sort)="onSort('supplier.companyName', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Zhotovitel GP</sort-by>
        </span>

        <!-- typ -->
        <span class="cell" *ngIf="!hideColumn('type')">
          <sort-by
            [selected]="'type' === list.filter.sortOrder.sortBy"
            (sort)="onSort('type', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Účel</sort-by>
        </span>

        <!-- stav -->
        <span class="cell" *ngIf="!hideColumn('status')">
          <sort-by
            [selected]="'status' === list.filter.sortOrder.sortBy"
            (sort)="onSort('status', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Stav</sort-by>
        </span>

        <!-- zalozeni -->
        <span class="cell" *ngIf="!hideColumn('createdDate')">
          <sort-by
            [selected]="'createdDate' === list.filter.sortOrder.sortBy"
            (sort)="onSort('createdDate', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum založení</sort-by>
        </span>

        <!-- k datu -->
        <span class="cell" *ngIf="!hideColumn('changedDate')">
          <sort-by
            [selected]="'changedDate' === list.filter.sortOrder.sortBy"
            (sort)="onSort('changedDate', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum poslední změny</sort-by>
        </span>

        <!-- importovano -->
        <span class="cell" *ngIf="!hideColumn('importedDate')">
          <sort-by
            [selected]="'importedDateReal' === list.filter.sortOrder.sortBy"
            (sort)="onSort('importedDateReal', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >Datum vložení GP</sort-by>
        </span>

        <span class="cell" *ngIf="!hideColumn('importedUser')">Vložil</span>

        <!-- resene parcely -->
        <span class="cell" *ngIf="!hideColumn('parcels')">Řešené parcely</span>

        <!-- stavebni objekt -->
        <span class="cell" *ngIf="!hideColumn('constructionObject')">Stavební objekt</span>
      </div>
    </div>

    <div class="row-group">
      <a class="row" *ngFor="let gpr of list.list" (click)="onClick(gpr)" [uiSref]="clickable ? undefined : 'symap.project.geometricPlanRequests.detail'" [uiParams]="{ id: gpr.id, tab: 'parcels-budouc' }">

        <!-- cislo spisu -->
        <span *ngIf="!hideColumn('folderNumber')" class="cell">{{ gpr.folder && gpr.folder.folderNumber ? gpr.folder.folderNumber : '' }}</span>

        <!-- cislo gp -->
        <span class="cell" *ngIf="!hideColumn('name')">{{ gpr.name }}</span>

        <!-- katastralni uzemi -->
        <span class="cell" *ngIf="!hideColumn('area')">
          <span *ngFor="let area of gpr.areas">
            {{ area.name }}
          </span>
        </span>

        <!-- LV -->
        <span class="cell" *ngIf="!hideColumn('lv')">
          <span *ngIf="gpr.parcels?.length">
            {{ getTitles(gpr) | titleNames }}
          </span>
        </span>

        <!-- zhotovitel -->
        <span class="cell" *ngIf="!hideColumn('supplier')">{{ gpr.supplier | projectSubjectName }}</span>

        <!-- typ -->
        <span class="cell" *ngIf="!hideColumn('type')">{{ requestService.getEnumLabel('type', gpr.type) }}</span>

        <!-- stav -->
        <span class="cell" *ngIf="!hideColumn('status')">{{ requestService.getEnumLabel('status', gpr.status) }}</span>

        <!-- zalozeni -->
        <span class="cell text-center" *ngIf="!hideColumn('date')">{{ gpr.createdDate | date }}</span>

        <!-- k datu -->
        <span class="cell text-center" *ngIf="!hideColumn('changedDate')">{{ gpr.changedDate | date }}</span>

        <!-- importovani -->
        <span class="cell text-center" *ngIf="!hideColumn('importedDate')">{{ gpr.importedDateReal | date }}</span>

        <!-- importoval -->
        <span class="cell text-center" *ngIf="!hideColumn('importedUser')">{{ gpr.importedUser | username }}</span>

        <!-- resene parcely -->
        <span class="cell no-padding" *ngIf="!hideColumn('parcels')">
          <cell-parcels
            [countParcels]="gpr.countParcels"
            [tooltipType]="'parcels'"
            [tooltipData]="{ filter: { filters: { geometricPlanRequestId: gpr.id }}}"
          ></cell-parcels>
        </span>

        <!-- stavebni objekt -->
        <span class="cell" *ngIf="!hideColumn('constructionObject')">
          <gmt-construction-object-list [constructionObjects]="gpr.constructionObjects"></gmt-construction-object-list>
        </span>
      </a>
    </div>
  </div>
</div>
